module.exports = __webpack_public_path__ + "media/images/landings/promotion_1/akkodis-logo-for-white-bg-86cbcb26ba06032a898104cf8fd9a08f.svg";